<div
  *ngIf="isSavannaDevice && showSavannaResultsLink && experimentCount > 0"
  class="savanna-experiment-link"
>
  <a routerLink="/savanna-results" [queryParams]="{ experimentid: experiment.experimentId }"
    >View Savanna Data</a
  >
</div>

<div
  class="fusion-experiment-link"
  [ngClass]="{ disabled: experimentCount <= 0 }"
  *ngIf="isSofia2Device || isSavannaDevice"
>
  <a
    [routerLink]="[]"
    [attr.aria-disabled]="experimentCount <= 0"
    (click)="onClickFusionCounterLink($event)"
  >
    Show Results
  </a>
  <span [hidden]="experimentCount === 0">({{ experimentCount }})</span>
</div>
